export const API_EVENT_START = 'API_EVENT_START';
export const API_EVENT_SUCCESS = 'API_EVENT_SUCCESS';
export const API_EVENT_FAIL = 'API_EVENT_FAIL';
export const API_EVENT_RESET = 'API_EVENT_RESET';
